import { render, staticRenderFns } from "./pricingTableComponent.vue?vue&type=template&id=39a37edc&scoped=true&"
import script from "./pricingTableComponent.vue?vue&type=script&lang=js&"
export * from "./pricingTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a37edc",
  null
  
)

export default component.exports